import React from "react";
import { useNavigate } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { money } from "@/lib/format";

export function MobileCartBar() {
  const { count, subtotal } = useCart();
  const nav = useNavigate();
  if (count === 0) return null;
  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 p-3 bg-obsidian/95 border-t border-gold/30 backdrop-blur-lg flex items-center justify-between shadow-2xl lg:hidden"
      data-testid="mobile-cart-bar"
    >
      <div className="flex items-center gap-3 text-cream">
        <div className="relative">
          <ShoppingBag size={22} className="text-gold" />
          <span className="absolute -top-2 -right-2 btn-gold text-[10px] font-bold rounded-full h-4 w-4 flex items-center justify-center">
            {count}
          </span>
        </div>
        <span className="font-mono font-semibold">{money(subtotal)}</span>
      </div>
      <button
        onClick={() => nav("/cart")}
        className="btn-gold rounded-full px-6 py-2.5 font-semibold text-sm"
        data-testid="mobile-cart-bar-checkout"
      >
        View Cart
      </button>
    </div>
  );
}
